import { ContentLoader, useViewport } from "@bca/ui-library";

const LoadingTableHead: React.FunctionComponent = () => {
  const viewport = useViewport();

  return (
    <tr>
      <td width={125} height={56}>
        <ContentLoader width="140px" height="24px">
          <rect width={80} height={24} rx={8} ry={8}></rect>
          <rect width={80} height={24} x={12} rx={8} ry={8}></rect>
        </ContentLoader>
      </td>
      {viewport.greaterThan.lg && (
        <td width={166} height={56}>
          <ContentLoader width="160px" height="24px">
            <rect width={80} height={24} rx={8} ry={8}></rect>
            <rect width={80} height={24} x={12} rx={8} ry={8}></rect>
          </ContentLoader>
        </td>
      )}
      <td width={154} height={56}>
        <ContentLoader width="140px" height="24px">
          <rect width={80} height={24} rx={8} ry={8}></rect>
          <rect width={80} height={24} x={12} rx={8} ry={8}></rect>
        </ContentLoader>
      </td>
      <td width={340} height={56}>
        <ContentLoader width="300px" height="24px">
          <rect width={280} height={24} rx={8} ry={8}></rect>
          <rect width={280} height={24} x={12} rx={8} ry={8}></rect>
        </ContentLoader>
      </td>
      {viewport.greaterThan.lg && (
        <td width={217} height={56}>
          <ContentLoader width="200px" height="24px">
            <rect width={140} height={24} rx={8} ry={8}></rect>
            <rect width={140} height={24} x={12} rx={8} ry={8}></rect>
          </ContentLoader>
        </td>
      )}
      <td width={125} height={56}>
        <ContentLoader width="140px" height="24px">
          <rect width={80} height={24} rx={8} ry={8}></rect>
          <rect width={80} height={24} x={12} rx={8} ry={8}></rect>
        </ContentLoader>
      </td>
      <td width={125} height={56}>
        <ContentLoader width="140px" height="24px">
          <rect width={80} height={24} rx={8} ry={8}></rect>
          <rect width={80} height={24} x={12} rx={8} ry={8}></rect>
        </ContentLoader>
      </td>
      <td width={125} height={56}>
        <ContentLoader width="140px" height="24px">
          <rect width={80} height={24} rx={8} ry={8}></rect>
          <rect width={80} height={24} x={12} rx={8} ry={8}></rect>
        </ContentLoader>
      </td>
    </tr>
  );
};

export default LoadingTableHead;
